import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import qs from 'qs';
import { RoboTask } from '../../models/RoboCall/RoboTask';
import { Status } from '../../models/common/Status';
import { RootState } from '../store';
import { apiClientWithApi } from '../../utils/http';

export interface RoboTaskState {
  items: RoboTask[];
  totalItemsCount: number;
  status: Status;
}

export interface GetRoboTasksResponse {
  items: RoboTask[];
  totalItemsCount: number;
}

export interface RoboTasksRequest {
  startDate: string;
  endDate: string;
  pageNumber: number;
  pageSize: number;
  phone: string;
  campaignIds: number[];
  selectedState: number | null;
}

const initialState: RoboTaskState = {
  items: [],
  totalItemsCount: 0,
  status: {
    responseLoading: true,
    responseError: null,
    requestSuccess: null,
    requestError: null,
  },
};

export const getRoboTasks = createAsyncThunk(
  'roboTask/getRoboTasks',
  async (request: RoboTasksRequest, { rejectWithValue }) => {
    try {
      const response = await apiClientWithApi.get<GetRoboTasksResponse>(
        '/tasks/robocall',
        {
          params: {
            'Filter.StartDate': request.startDate,
            'Filter.EndDate': request.endDate,
            PageIndex: request.pageNumber,
            PageSize: request.pageSize,
            phone: request.phone,
            campaignIds: request.campaignIds,
            selectedState: request.selectedState,
          },
          paramsSerializer: function (params) {
            return qs.stringify(params, { arrayFormat: 'repeat' });
          },
        },
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error.message);
      } else return rejectWithValue('Не удалось получить список заданий!');
    }
  },
);

export const roboTaskSlice = createSlice({
  name: 'roboTask',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getRoboTasks.pending, (state) => {
        state.status.responseLoading = true;
        state.status.responseError = null;
      })
      .addCase(getRoboTasks.fulfilled, (state, action) => {
        state.status.responseLoading = false;
        state.status.responseError = null;
        state.items = action.payload.items;
        state.totalItemsCount = action.payload.totalItemsCount;
        return state;
      })
      .addCase(getRoboTasks.rejected, (state) => {
        state.status.responseLoading = false;
        state.status.responseError = 'Не удалось загрузить задания';
      });
  },
});

export default roboTaskSlice.reducer;

export const selectTasks = (state: RootState) => state.roboTask.items;

export const roboTaskStatus = (state: RootState) => state.roboTask.status;

export const totalTasks = (state: RootState) => state.roboTask.totalItemsCount;
